import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { DriversComponent } from 'app/components/home/drivers/drivers.component';
import {BackOfficeEnum, RiderVehicleTypeEnum, ServiceTypeEnum} from 'app/models';
import {AppDataService} from 'app/services';

@Component({
    selector: 'drivers-filter',
    templateUrl: './drivers-filter.component.html',
    styleUrls: ['./drivers-filter.component.scss',
        '../../../../../styles/style-layout.scss']
})
export class DriversFilterComponent implements OnInit {
    @Input()
    public driversComponent!: DriversComponent;

    @Input()
    public filterObj: any = {};

    @Input()
    public visibleDriversFilter: boolean = false;

    public startDateJoin: Date = new Date();
    public endDateJoin: Date = new Date();

    @Output() changedVisibleDriversFilterFilterEmit = new EventEmitter<boolean>();

    changedVisibleDriversFilterFilter(increased: any) {
        this.changedVisibleDriversFilterFilterEmit.emit(increased);
    }

    constructor(public appData: AppDataService) { }

    ngOnInit(): void { }

    public clickFilter() {
        this.driversComponent.filterObj = this.filterObj;
        this.driversComponent.getRiders(0);
        this.cancel();
    }

    clear() {
        this.filterObj = {};
    }

    cancel() {
        this.changedVisibleDriversFilterFilter(false);
    }

    protected readonly serviceType = ServiceTypeEnum;
    protected readonly vehicleType = RiderVehicleTypeEnum;
    protected readonly BackOfficeEnum = BackOfficeEnum;
}
